import { VStack, HStack, Text, Image, Icon } from "@chakra-ui/react";
import { ExternalLinkIcon, CalendarIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";
import dayjs from "dayjs";
import { KYDEventSummary } from "@common/interfaces/KYDEvent";
import { FaMapMarkerAlt } from "react-icons/fa";
import { KYDAdminFeed } from "@common/interfaces/KYDOrganization";

interface EventCardProps {
  event: KYDEventSummary | KYDAdminFeed["external_events"][number];
  isExternal?: boolean;
}

const EventCard = ({ event, isExternal = false }: EventCardProps) => {
  const venueName =
    "venue" in event && event.venue != null
      ? event.venue.name
      : "venue_name" in event
        ? event.venue_name
        : "";
  const address =
    "venue" in event && event.venue != null ? (event.venue.address ?? "") : "";
  const startAt = dayjs(event.start_at).format("MMM D, YYYY");

  const renderDescription = (text: string) => {
    return (
      <Text
        overflow="hidden"
        color="rgba(26, 32, 44, 0.70)"
        textOverflow="ellipsis"
        fontFamily="Work Sans"
        fontSize="12px"
        fontStyle="normal"
        fontWeight="400"
        lineHeight="120%"
      >
        {text}
      </Text>
    );
  };
  return (
    <Box
      borderRadius="8px"
      border="1px solid rgba(0, 0, 0, 0.10)"
      w="100%"
      position="relative"
      bg="white"
    >
      {isExternal && (
        <HStack
          borderTopRadius="8px"
          top="8px"
          right="8px"
          p={2}
          bg="#E6E6E6"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text
            color="rgba(17, 17, 17, 0.50)"
            fontFamily="Work Sans"
            fontSize="11px"
            fontStyle="normal"
            fontWeight="500"
            lineHeight="100%"
          >
            External Event
          </Text>
          <Icon fontSize="12px" as={ExternalLinkIcon} color="#1A202CBF" />
        </HStack>
      )}
      <HStack spacing={4} p={4}>
        <Image
          src={event.image}
          boxSize="100px"
          objectFit="cover"
          borderRadius="4px"
        />
        <VStack
          align="flex-start"
          spacing={2}
          w="100%"
          justifyContent="space-between"
          h={100}
        >
          <Text
            fontSize="16px"
            fontWeight="500"
            lineHeight="140%"
            color="#222"
            overflow="hidden"
            textOverflow="ellipsis"
            fontFamily="Work Sans"
            fontStyle="normal"
            textDecoration="underline"
            textDecorationStyle="solid"
            height="60px"
          >
            {"name" in event ? event.name : event.title}
          </Text>
          <HStack fontSize="14px" color="gray.600">
            <CalendarIcon />
            {renderDescription(startAt)}
          </HStack>
          {venueName ? (
            <HStack fontSize="14px" color="gray.600" alignItems="flex-start">
              <Icon as={FaMapMarkerAlt} />
              <VStack align="flex-start" justify="flex-start" gap={0}>
                {renderDescription(address)}
                {renderDescription(venueName)}
              </VStack>
            </HStack>
          ) : (
            <HStack />
          )}
        </VStack>
      </HStack>
    </Box>
  );
};

export default EventCard;
